import {PayloadAction} from "@reduxjs/toolkit";
import {
    GridColumnOrderChangeParams,
    GridColumnVisibilityModel,
    GridDensity,
    GridFilterModel,
    GridLogicOperator,
    GridPaginationModel,
    GridSortModel
} from "@mui/x-data-grid-pro";

export interface GridState {
    filter: GridFilterModel,
    sort: GridSortModel,
    seq: number,
    paginationModel: GridPaginationModel,
    columns: GridColumnVisibilityModel,
    density: GridDensity
}

export const initialGridState = {
    filter: <GridFilterModel>{items: [], logicOperator: GridLogicOperator.And},
    seq: 0,
    sort: <GridSortModel>[],
    paginationModel: {
        page: 1,
        pageSize: 50,
    },
    columns: {},
    density: "compact" as GridDensity
}

type GridReducer = {
    setFilter: (state: GridState, action: PayloadAction<GridFilterModel>) => void;
    setSort: (state: GridState, action: PayloadAction<GridSortModel>) => void;
    setPaginationModel: (state: GridState, action: PayloadAction<GridPaginationModel>) => void;
    columnOrderChange: (state: GridState, action: PayloadAction<GridColumnOrderChangeParams>) => void;
    setColumns: (state: GridState, action: PayloadAction<GridColumnVisibilityModel>) => void
    setDensity: (state: GridState, action: PayloadAction<GridDensity>) => void
}

const reducers: GridReducer = {
    setFilter: (state: GridState, action: PayloadAction<GridFilterModel>) => {
        state.filter = action.payload
    },
    setSort: (state: GridState, action: PayloadAction<GridSortModel>) => {
        state.sort = action.payload;
    },
    setPaginationModel: (state: GridState, action: PayloadAction<GridPaginationModel>) => {
        state.paginationModel = action.payload
    },
    columnOrderChange: (state: GridState, action: PayloadAction<GridColumnOrderChangeParams>) => {

    },
    setColumns: (state: GridState, action: PayloadAction<GridColumnVisibilityModel>) => {
        state.columns = action.payload
    },
    setDensity: (state: GridState, action: PayloadAction<GridDensity>) => {
        state.density = action.payload
    }
}

export default reducers
